import React from 'react';

const AvailabilityPage = () => {
  return (
    <div className="bg-white text-gray-700">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {/* Section 1: Page Title */}
        <section className="text-center mb-10 md:mb-12">
          <h1 className="text-3xl sm:text-4xl font-semibold uppercase tracking-wider text-yellow-600">
            Select Availabilities
          </h1>
        </section>
        
        {/* The html source is in the public folder as appfolio-embed.html */}
        {/* Section 2: Embedded Listings (AppFolio via iframe) */}
        <section>
          <div className="w-full">
            {/* This div will contain and size the iframe */}
            <div 
              className="border border-gray-300 rounded-lg bg-gray-50"
              style={{ 
                height: '550px', // Set the desired height for your listings view.
                                  // Add a bit more than AppFolio's 500px if it has its own padding/chrome.
                overflow: 'hidden', // Prevents this container from showing scrollbars if iframe is slightly off
                position: 'relative' // Good practice for iframe containers
              }}
            >
              <iframe
                src="/appfolio-embed.html" // Path to the HTML file in your public folder
                title="Property Availabilities"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none', // Remove default iframe border
                }}
                // sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                // The sandbox attribute enhances security.
                // - allow-scripts: Essential for AppFolio JS.
                // - allow-same-origin: Often needed for API calls or resource loading.
                // - allow-forms: If AppFolio includes forms.
                // - allow-popups: If AppFolio tries to open new windows/tabs.
                // Start with "allow-scripts allow-same-origin". Add others if features break.
                // If it still doesn't work, try removing sandbox temporarily for testing,
                // but aim to use it with the minimal necessary permissions.
              />
            </div>
            <p className="text-center text-xs text-gray-400 mt-2">
              Listing data provided by AppFolio. If you encounter issues, please try refreshing.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AvailabilityPage;